import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  Heading,
  Button,
  useToast,
  useColorModeValue,
  Flex,
  VStack,
  Checkbox,
  HStack,
  Alert,
  AlertTitle,
  AlertDescription,
  CloseButton,
  Image,
} from "@chakra-ui/react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { Tenant } from "../Common/types";


interface TokenPayload {
    sub: string;
    role_id: number;
    tenant_id: number;
    exp?: number;
  }

const ReviewTenant = () => {

    const buttonBg = useColorModeValue(
        'linear-gradient(to right, blue.50, blue.100)',
        'linear-gradient(to right, blue.600, blue.700)'
      );
      const buttonHoverBg = useColorModeValue(
        'blue.200',
        'blue.500'
      );
    

  const { tenant_id } = useParams<{ tenant_id: string }>();

  const cardbg = useColorModeValue("gray.50", "gray.700");

  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);

    const [uploadSummary, setUploadSummary] = useState<null | {
      upload_success:boolean
      error: string;
    }>(null);

  const [file, setFile] = useState<File | null>(null);

    // Function to get tenant_id from the token
    const getTenantIdFromToken = (token: string): number | null => {
        try {
          const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
          return decoded.tenant_id || null;
        } catch (error) {
          console.error("Error decoding token:", error);
          return null;
        }
      };

  // Assuming the `Tenant` type is already imported
const [tenant, setTenant] = useState<Tenant>({
    tenant_id :0,
    name: '', 
    description: '',
    slug:'',
    contact_email :'',
    contact_phone :'',
    support_email :'',
    billing_email :'',
    is_active : true,
  });

  const toast = useToast();



  const fetchTenant = async () => {
    try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
       
      const response = await axios.get(`${apiurl}/tenant/${tenant_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setTenant(response.data);
      console.log("Tenant Data Fetched", response.data)
    } catch (error) {
      console.error("Failed to load enrolled students", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tenantId = getTenantIdFromToken(token) ?? 0; // Use 0 if tenantId is null
      console.log("Tenant ID:", tenantId);
  
      setTenant((prevDetails) => ({
        ...prevDetails, // Preserve other fields
        tenant_id: tenantId, // Update tenant_id
      }));
  
      setSelectedTenant(tenantId);

      if (Number(tenant_id) > 0)
      {
        console.log("Tenant Id:",tenant_id);
        fetchTenant();
      }

    }
  }, [tenant_id]);
  

const handleInputChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
) => {
  const { name, type } = e.target;
  const value = type === "checkbox" ? (e.target as HTMLInputElement).checked : e.target.value;

  setTenant((prev) => ({
    ...prev,
    [name]: value,
  }));
};
  

  const handleTimeChange = (time: string, name: string): void => {
    setTenant((prev) => ({ ...prev, [name]: `${time}:00` }));
  };
  
  const handleDateChange = (date: string, name: string): void => {
    setTenant((prev) => ({
      ...prev,
      [name]: date ? new Date(date) : null,  // Convert only if non-empty, else store as null
    }));
  };
  

   const handleSaveTenant = async () => {
    if (Number(tenant_id) > 0)
        { 
            handleUpdateTenant();
        }
        else
        {
            handleCreateTenant();
        }
   }

  const handleCreateTenant = async () => {
    console.log("Tenant Details sent to backend for processing",tenant);
    try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
        const response = await axios.post(`${apiurl}/tenant/create`, tenant, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        //setCourses(response.data);
        toast({ title: "Tenant Successfully created" });
      } catch (error) {
        
        toast({ title: "Error creating tenant", status: "error" });
      }
  };

  const handleUpdateTenant = async () => {
    console.log("Tenant Details sent to backend for processing",tenant);

    try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';

        const response = await axios.put(`${apiurl}/tenant/update/${tenant_id}`, tenant, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        //setCourses(response.data);
        toast({ title: "Tenant Successfully updated" });
      } catch (error) {
        
        toast({ title: "Error updating tenant", status: "error" });
      }
        
  };


    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
        setFile(event.target.files[0]);
        setUploadSummary(null);  // clear old message
        }
    };  

    const handleUpload = async () => {
        if (!file) {
        toast({
            title: "No file selected",
            description: "Please select a .png or .jpg or .jpeg file first.",
            status: "warning",
            duration: 3000,
            isClosable: true,
        });
        return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
        const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
        const response = await axios.put(apiUrl + `/tenant/update-logo/${tenant_id}`, formData, {
            headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        });

        const data = response.data;
        setUploadSummary(data);

        fetchTenant(); // refresh list
        } catch (error) {
        setUploadSummary(null);  // clear summary if it fails

        toast({
            title: "Upload Failed",
            description: "An error occurred while uploading.",
            status: "error",
            duration: 3000,
            isClosable: true,
        });
        }
    };

    const handleRemoveLogo = async () => {

      
        try {
        const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8000";
        const response = await axios.put(
                apiUrl + `/tenant/remove-logo/${tenant_id}`,
                {},  // no body data
                {
                    headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
                );

        const data = response.data;
        setUploadSummary(data);

        toast({
            title: "Remove Succeced",
            description: "Successfully removed logo.",
            status: "success",
            duration: 3000,
            isClosable: true,
        });

        fetchTenant(); // refresh list
        } catch (error) {
        setUploadSummary(null);  // clear summary if it fails

        toast({
            title: "Remove Failed",
            description: "An error occurred while removing logo.",
            status: "error",
            duration: 3000,
            isClosable: true,
        });
        }
    };



  return (
    <Box as="main" mx="auto" p={10} >

    <VStack>
    <Heading size={"md"}>Tenant Details</Heading>
    </VStack>

        <Box mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="lg">
            <Heading size="sm" mb={6}>Update Logo</Heading>
            <VStack spacing={4} align="stretch" mb={4}>
                                {/* Logo */}
            <Flex justify="center" mb={6}>
                <Image
                src={tenant.logo_image_url}
                alt={`${tenant.name} logo`}
                boxSize={{ base: "80px", md: "100px" }}
                objectFit="contain"
                borderRadius="md"
                />
            </Flex>
                <Input type="file" accept=".png,.jpg,.jpeg" onChange={handleFileChange} size={"sm"} maxWidth="800px" />
            </VStack>
            <HStack mt={6} spacing={3}>
            <Button colorScheme="blue" size="sm" onClick={handleUpload}>
                Upload New Logo
            </Button>
              <Button size="sm" 
                onClick={() => {
                  if (window.confirm("Are you sure you want to remove this logo?")) {
                    handleRemoveLogo();
                  }
                }}>
                Remove
              </Button>
            </HStack>
            {uploadSummary && (
            <Alert status="info" variant="subtle" mt={4}
            flexDirection="column"
            alignItems="flex-start"
            position="relative"
            >
                <AlertTitle mb={1} >Upload Summary</AlertTitle>
                <AlertDescription>
                <VStack align="start">
                     {uploadSummary.upload_success ? (
                        <Text fontSize="sm">✅ Logo Successfully updated</Text>
                        ) : (
                        <Text fontSize="sm" color="red.600">
                            ❌ Error: {uploadSummary.error}
                        </Text>
                        )}
                </VStack>
                </AlertDescription>
                <CloseButton position="absolute" right="8px" top="8px" onClick={() => setUploadSummary(null)} />
            </Alert>
            )}
        </Box>


        <Box mt={4} bgColor={cardbg} borderRadius="sm" p={4} boxShadow="lg">
            <Text mb={4} fontSize="sm" fontWeight="bold">Tenant Details</Text>
            <VStack spacing={4} align="stretch">
                <FormControl id="name" isRequired>
                    <Input
                    name="name"
                    placeholder="Tenant Name*"
                    size="sm"
                    value={tenant.name}
                    onChange={handleInputChange}
                    />

                </FormControl>

                <FormControl id="description" isRequired>
                    <Input
                    name="description"
                    placeholder="Tenant Description*"
                    size="sm"
                    value={tenant.description}
                    onChange={handleInputChange}
                    />

                </FormControl>

                <FormControl id="slug" isRequired>
                    <Input
                    name="slug"
                    placeholder="Tenant Slug*"
                    size="sm"
                    value={tenant.slug}
                    onChange={handleInputChange}
                    />

                </FormControl>

                <FormControl id="contact_email" isRequired>
                    <Input
                    name="contact_email"
                    placeholder="Tenant Contact Email*"
                    size="sm"
                    value={tenant.contact_email}
                    onChange={handleInputChange}
                    />

                </FormControl>

                <FormControl id="contact_phone" >
                    <Input
                    name="contact_phone"
                    placeholder="Tenant Contact Phone"
                    size="sm"
                    value={tenant.contact_phone}
                    onChange={handleInputChange}
                    />

                </FormControl>

                <FormControl id="support_email">
                    <Input
                    name="support_email"
                    placeholder="Tenant Support Email"
                    size="sm"
                    value={tenant.support_email}
                    onChange={handleInputChange}
                    />

                </FormControl>

                <FormControl id="billing_email" isRequired>
                    <Input
                    name="billing_email"
                    placeholder="Tenant Billing Email"
                    size="sm"
                    value={tenant.billing_email}
                    onChange={handleInputChange}
                    />

                </FormControl>

            {/* Status */}
            <FormControl id="is_active" isRequired >
            <Flex align="center" gap={4}>
                <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Status</FormLabel>
                <Checkbox
                name="is_active"
                isChecked={tenant.is_active}
               onChange={handleInputChange}
                >
                Active
                </Checkbox>
            </Flex>
            </FormControl>
            </VStack>

                    {/* Save Button */}
        <Box textAlign="left" mt={4}>
            <Button mb={2} colorScheme="blue" size="sm" borderRadius={"sm"} onClick={handleSaveTenant}>
            Save Tenant
            </Button>
        </Box>
        </Box>




    </Box>
  );
};

export default ReviewTenant;
